import React, { FC } from 'react';
import isNil from 'lodash/isNil';
import { ProductSupplementaries } from '../ProductSupplementaries';
import { ProductReviews } from '../ProductReviews';
import { ProductMetaData } from '../../../../models/Product';

type Props = {
    readonly product: ProductMetaData;
    readonly isLibx?: boolean;
};

const ProductDetailExtendedInfo: FC<Props> = props => {
    const product = props.product;
    const teaser = <ProductSupplementaries product={product} types={['Teaser']} isLibx={props.isLibx} />;
    const productSummary = product.summary?.replace(/\n\n/g, '</p><p>') ?? '';

    return (
        <div className="pd-details-inner" data-displayname="ProductDetailExtendedInfo">
            <div className="selections">
                {product.selections?.map(selection => {
                    return <p>{selection}</p>;
                })}
                <ProductSupplementaries product={product} types={['SelectionSummary']} />
            </div>

            <div className="awards">
                {product.awards?.map(award => {
                    return <p>{`${award.position} ${award.name} ${award.year}`}</p>;
                })}
                <ProductSupplementaries product={product} types={['AwardSummary']} />
            </div>

            <div className="highlight-quotes">
                <ProductSupplementaries product={product} types={['Highlight Quote']} />
            </div>

            <div className="marketing-points">
                <ProductSupplementaries product={product} types={['Marketing points']} />
            </div>

            {isNil(product.seriesName) ? null : teaser}

            <p className="product-summary" dangerouslySetInnerHTML={{ __html: productSummary }} />

            <div className="reviews">
                <ProductReviews reviews={product.reviews} types={['Highlight Review']} />

                <ProductReviews reviews={product.reviews} types={['Review']} />
            </div>

            <div className="quotes">
                <ProductSupplementaries product={product} types={['Quote']} />
            </div>
        </div>
    );
};

export default ProductDetailExtendedInfo;
